import React from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { Box, Container, Typography, Paper, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export const LoginPage: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = React.useState<string | null>(null);

  // Redirect when authenticated (handles One Tap login from AuthContext)
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    if (!credentialResponse.credential) {
      setError('Failed to receive credentials from Google');
      return;
    }

    try {
      await login(credentialResponse.credential);
      navigate('/');
    } catch (err) {
      console.error('Error processing Google login:', err);
      setError(err instanceof Error ? err.message : 'Failed to process login. Please try again.');
    }
  };

  const handleGoogleError = () => {
    setError('Google sign-in failed. Please try again.');
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: '100%', textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Edge Admin
          </Typography>
          <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
            Sign in with your Google account
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
            />
          </Box>

          <Typography variant="caption" color="textSecondary" sx={{ mt: 3, display: 'block' }}>
            Access is restricted to @hexacontainment.com email addresses
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};
